import { ProductTypeAllocation } from './product-type-allocation';
import { ProductCategoryDeviceAllocation } from './product-category-device-allocation';
import Base, { baseInit } from './base';

export class ProductCategoryAllocation extends Base {
  id = null; // Integer
  productCategoryId = null; // Integer
  budgetPercentage = null; // Integer
  avgCPM = null; // Float
  budget = null; // Integer
  impressions = null; // Integer
  productTypeAllocations = null; // [ProductTypeAllocations {}]
  productCategoryDeviceAllocations = null;

  constructor(data) {
    super(data);
    baseInit(this, data);
    if (this.productTypeAllocations === null) {
      this.productTypeAllocations = new ProductTypeAllocation();
    }
    if (this.productCategoryDeviceAllocations === null) {
      this.productTypeAllocations = new ProductCategoryDeviceAllocation();
    }
  }
}
